import DropzoneComponentChunks from "./DropzoneComponentChunks/DropzoneComponentChunks";
import DropzoneComponent from "./DropzoneComponent";

const DropzoneComponentMain = ({component, actionsContext, containerArrayPath}) => {
    if (component?.properties?.uploadChunks) {
        return (
            <DropzoneComponentChunks
                component={component}
                containerArrayPath={containerArrayPath}
            />
        )
    }

    return (
        <DropzoneComponent
            component={component}
            containerArrayPath={containerArrayPath}
        />
    )
}

export default DropzoneComponentMain